// Fotolijst (0064_photo_frame). Handgeschreven zoals notes.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/photos.ts); openapi.contract.test.ts bewaakt elke aanroep.
const id = (v) => encodeURIComponent(v);
export function createPhotoFrameClient(t) {
    return {
        list: () => t.request('GET', '/v1/app/photos'),
        upload: (input) => t.request('POST', '/v1/app/photos', input),
        update: (photoId, input) => t.request('PATCH', `/v1/app/photos/${id(photoId)}`, input),
        remove: (photoId) => t.request('DELETE', `/v1/app/photos/${id(photoId)}`),
        /** De foto zelf (privé-cache); 'm' = 800 px voor de lijst, anders 1600 px. */
        fileUrl: (photoId, size = 'm') => `${t.baseUrl}/v1/app/photos/${id(photoId)}/file?size=${size}`,
    };
}
//# sourceMappingURL=photoFrame.js.map